/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

// Used to generate the requirejs layers bundle
// Only declare the entry points, not all modules!
define([
	'./visIndicators/VisIndicators',
	'./visIndicators/conditionalViewIndicator/ConditionalViewIndicator',
	'./dataPointActions/DataPointActions',
	'./selections/dataPointSelections/DataPointSelections',
	'./visDnD/VisDnD',
	'./slotActions/SlotActions',
	'./common/contextualGridAction/ContextualGridAction',
	'./common/textAction/TextAction',
	'./expandCollapse/ExpandCollapse',
	'./keyDrivers/KeyDriversProvider',
	'./vis-smartcolormap/SmartColorRenderStepProvider',
	'./viprPropertyProvider/ViprPropertyProvider',
	'./visPropertyProvider/VisPropertyProvider',
	'./conditionalFormatting/ConditionalFormatting',
	'./dnD/VisDnDUtils',
	'./smart-title/SmartTitleFeatureProvider',
	'./overlay/DropZonesOverlayState',
	'./overlay/DropZonesOverlayDOM',
	'./dataQueryExecution/SharedSlotVisQueryModifier'
], () => {});